import { render } from "./mped-amortization-group-view.vue?vue&type=template&id=5ae468bd"
import script from "./mped-amortization-group-view.vue?vue&type=script&setup=true&lang=js"
export * from "./mped-amortization-group-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/mped/views/amortization/main-asset/mped-amortization-group-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ae468bd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ae468bd', __exports__)) {
    api.reload('5ae468bd', __exports__)
  }
  
  module.hot.accept("./mped-amortization-group-view.vue?vue&type=template&id=5ae468bd", () => {
    api.rerender('5ae468bd', render)
  })

}


export default __exports__